import { URL } from "../../api/Api";
import { SOW } from "../Action";
import { catchError, GET, getToken, PUT } from "../axios/Axios";

export const SowToEnrich = async (formData) => {
  try {
    const token = await getToken();
    const response = await fetch(`${URL}/intake/jobdata/ignite`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (response.status === 401 || response.status === 403) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
      return;
    } else if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error.message.includes("401") || error.message.includes("403")) {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.href = "/auth/login";
    }
    throw catchError(error);
  }
};

export const SowEnrich = (data) => {
  return {
    type: SOW.sowEnrich,
    data: data,
  };
};

export const SowEnrichGetCall = async (id) => {
  try {
    const response = await GET(`${URL}/intake/jobdata/ignite/${id}`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const SowActivation = async (id) => {
  try {
    const response = await PUT(
      `${URL}/intake/jobdata/ignite/activation/${id}`,
      {}
    );
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const SowJudicaFilter = (data) => {
  return {
    type: SOW.sowJudicaFilter,
    data: data,
  };
};
